import { beginTask, endTask } from 'redux-nprogress';
import { loadWeeks, selectCurrent, selectWeeks } from '../../../../store/reducers/season';
import { selectQuery } from '../../../../store/reducers/location.selectors';
import { selectFormulasState } from '../../../../store/reducers/formula';
import routes from '../../../routes.global';
import viewNames from '../../../../store/actions/view.types';
import { loadToolDescriptions } from '../../../../store/reducers/toolDescriptions';

// ------------------------------------
// Selectors
// ------------------------------------
export const STORE_KEY = 'top200PPR';
export const selectTop200PPRState = state => state[STORE_KEY];
export const selectTop200PPR = state => selectTop200PPRState(state).currentTop200PPR;

// ------------------------------------
// Reducer
// ------------------------------------
const actions = {};
const initialState = {
  currentTop200PPR: {},
  year: null,
  week: null,
  formulaId: 1,
  hasLoaded: false,
  error: null,
};

export const reducer = (state = initialState, action) => {
  const handler = actions[action.type];

  return handler ? handler(state, action) : state;
};

export default reducer;

// ------------------------------------
// Load Cheat Sheet from api
// ------------------------------------
export const LOAD_TOP200PPR_REQUEST = `${STORE_KEY}/LOAD_TOP200PPR_REQUEST`;
export const LOAD_TOP200PPR_SUCCESS = `${STORE_KEY}/LOAD_TOP200PPR_SUCCESS`;
export const LOAD_TOP200PPR_ERROR = `${STORE_KEY}/LOAD_TOP200PPR_ERROR`;

export const loadTop200PPRRequest = payload => ({
  type: LOAD_TOP200PPR_REQUEST,
  payload: { ...payload },
});
export const loadTop200PPRSuccess = ({ cheatsheet }, year, week, formulaId) => ({
  type: LOAD_TOP200PPR_SUCCESS,
  payload: { cheatsheet, year, week, formulaId },
});
export const loadTop200PPRError = error => ({
  type: LOAD_TOP200PPR_ERROR,
  payload: { error },
});

actions[LOAD_TOP200PPR_REQUEST] = (state, { payload }) => ({ ...state,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200PPR_SUCCESS] = (state, { payload }) => ({ ...state,
  hasLoaded: true,
  currentTop200PPR: payload.cheatsheet,
  year: payload.year,
  week: payload.week,
  formulaId: payload.formulaId,
});
actions[LOAD_TOP200PPR_ERROR] = (state, { payload }) => ({ ...state,
  hasLoaded: false,
  error: payload.error,
});

export const loadTop200PPR = (year, week, formulaId) => async (dispatch, getState, { api }) => {
  try {
    dispatch(beginTask());
    dispatch(loadTop200PPRRequest(year, week, formulaId));
    const top200PPR = await api.cheatSheets.getByWeekTop200PPR(year);

    return dispatch(loadTop200PPRSuccess(top200PPR, year, week, formulaId));
  } catch (error) {
    console.error(error);
    return dispatch(loadTop200PPRError(error));
  } finally {
    dispatch(endTask());
  }
};

// ------------------------------------
// View
// ------------------------------------
export const TOP200PPR_VIEW = `${STORE_KEY}/TOP200PPR_VIEW`;

viewNames[TOP200PPR_VIEW] = 'Top200PPR';
routes[TOP200PPR_VIEW] = {
  path: '/fantasy-football-rankings-cheat-sheets/:year/top-200-ppr',
  thunk: async (dispatch, getState) => {
    const state = getState();
    let { week, formulaId } = selectQuery(state);
    let { year } = state.location.payload;

    const { season: currentYear, week: currentWeek } = selectCurrent(state, 'projections');

    if (!formulaId) formulaId = selectFormulasState(state).defaultFormula;

    await dispatch(loadWeeks(year));

    if (typeof week !== 'number') {
      if (year === currentYear) {
        week = currentWeek;
      } else {
        week = selectWeeks(getState(), year, 'projections')[0];
      }
    }

    // Needs to await otherwise data won't load on SSR
    await dispatch(loadTop200PPR(year, week, formulaId));
    await dispatch(loadToolDescriptions());
  },
};



// WEBPACK FOOTER //
// ./src/app/views/Top200PPR/module/top200PPR.js